import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  PaymentInProgressBadgeStyled,
} from 'pages/company/WorkspaceRoute/components/DocumentPreview/components/StyledComponents';

const PaymentInProgressBadge = () => (
  <PaymentInProgressBadgeStyled>
    <FormattedMessage id="documents.item.badge.paymentInProgress" defaultMessage="Payment in progress" />
  </PaymentInProgressBadgeStyled>
);

export default memo(PaymentInProgressBadge);
